"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    PillSelection: {
      background: theme['$pillselection-background'],
      width: 'max-content',
      borderRadius: '100px',
      '& ul': {
        display: 'flex',
        flexDirection: 'row',
        listStyle: 'none',
        padding: 2,
        margin: 0
      },
      position: 'relative'
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map